import { customElement, html, internalProperty, LitElement, property } from "lit-element";
import {unsafeHTML} from 'lit-html/directives/unsafe-html.js';

@customElement("faq-element")
export class FaqElementComponent extends LitElement {
  constructor() {
    super();
  }

  createRenderRoot(): LitElement {
    return this;
  }

  @property()
  question: string = "";

  @property()
	answer: string = "";
	
	@internalProperty()
	isActive: boolean = false;

  public render() {
    return html`
        <dt>
					<a class="article_faq-link${!this.isActive ? ' active' : ''}" @click="${this.toggleQuestion}" href="">
						<span class="icon icon-arrow-right"></span>${this.question}
          </a>
        </dt>
        <dd class="article_faq-text${!this.isActive ? ' active' : ''}">
					${unsafeHTML(this.answer)}
        </dd>`;
  }

  toggleQuestion(): void {
		this.isActive = !this.isActive;
  }
}

declare global {
  interface HtmlElementTagNameMap {
    "faq-element": FaqElementComponent;
  }
}
